import React, { useEffect, useState } from "react";

const STEPS = [
  "INIT // CHIEF AUDITOR",
  "VALIDATING INPUT [BRAND, MODEL]",
  "RESOLVING CATEGORY CONTEXT",
  "DISPATCHING APIFY SERP SCRAPER",
  "FETCHING YOUTUBE SIGNALS (site:youtube.com)",
  "FETCHING TIKTOK / INSTAGRAM SIGNALS",
  "FETCHING SHOPEE + TOKOPEDIA LISTINGS",
  "FETCHING KASKUS / REDDIT / FORUMS",
  "CLASSIFYING: PAID vs ORGANIC",
  "WEIGHTING EVIDENCE HIERARCHY",
  "INVOKING CLAUDE LLM",
  "COMPILING REPORT...",
];

export default function TerminalLoader() {
  const [done, setDone] = useState(0);
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    const t = setInterval(() => {
      setDone((d) => (d < STEPS.length - 1 ? d + 1 : d));
    }, 7000);
    const s = setInterval(() => setElapsed((e) => e + 1), 1000);
    return () => { clearInterval(t); clearInterval(s); };
  }, []);

  return (
    <div className="bg-black text-[#00ff88] border-2 border-black p-5 md:p-6 font-mono text-xs md:text-sm shadow-brutal" data-testid="terminal-loader">
      <div className="flex items-center justify-between text-[#00ff88]/70 uppercase tracking-[0.2em] text-[10px] border-b border-[#00ff88]/30 pb-2">
        <span>// FAKTA-PRODUK · CHIEF-AUDITOR · STREAM</span>
        <span>RUN ID: {Math.random().toString(36).slice(2, 10).toUpperCase()}</span>
      </div>
      <div className="mt-3 space-y-1.5 max-h-[420px] overflow-hidden">
        {STEPS.slice(0, done + 1).map((s, i) => (
          <div key={i} className="flex items-start gap-2">
            <span className="text-[#00ff88]/60 select-none">[{String(i + 1).padStart(2, "0")}]</span>
            <span className="flex-1">{s}</span>
            <span className={i < done ? "text-[#00ff88]" : "text-[#00ff88]/60"}>
              {i < done ? "[OK]" : <span className="cursor-blink"></span>}
            </span>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-3 border-t border-[#00ff88]/30 text-[#00ff88]/60 text-[10px] uppercase tracking-[0.18em] flex justify-between">
        <span>Elapsed: {elapsed}s</span>
        <span>Estimasi: 30–120 detik (premium lebih lama)</span>
      </div>
    </div>
  );
}
